export default __webpack_public_path__ + "static/media/clv.d49997a2.svg";